import './assets/main.css'
import '@unocss/reset/tailwind.css'
import 'virtual:uno.css'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import directives from './directives'
import router from './router'

createApp(App)
  .use(router)
  .use(directives)
  .use(createPinia())
  .mount('#app')
